import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, currentUser } from "../lib/api";
import { formatQAR } from "../lib/money";
const SCOPES = [
    { key: "open", label: "Open" },
    { key: "mine", label: "Awaiting me", managementOnly: true },
    { key: "all", label: "All" },
];
const describe = (r) => {
    const p = r.payload || {};
    const parts = [];
    if (p.newAmountMinor != null) parts.push(`New receivable ${formatQAR(p.newAmountMinor / 100)}`);
    if (p.chequeNumber) parts.push(`Cheque ${p.chequeNumber}`);
    if (p.reason) parts.push(p.reason);
    return parts.join(" · ");
};
export function Approvals() {
    const isManagement = currentUser()?.role === "MANAGEMENT";
    const [scope, setScope] = useState(isManagement ? "mine" : "open");
    const [items, setItems] = useState([]);
    const [error, setError] = useState(null);
    const [busyId, setBusyId] = useState(null);
    function load() {
        api
            .get(`/approvals?scope=${scope}`)
            .then((r) => setItems(r.items))
            .catch(() => setError("Couldn't load approval requests."));
    }
    useEffect(load, [scope]);
    async function decide(id, decision) {
        let comment;
        if (decision === "REJECTED") {
            comment = window.prompt("Reason for rejecting (sent to the requester):");
            if (!comment || !comment.trim()) return;
        }
        setBusyId(id);
        setError(null);
        try {
            await api.post(`/approvals/${id}/decide`, { decision, comment: comment?.trim() });
            load();
        }
        catch (e) {
            setError(e?.message && e.status !== 0 ? e.message : "Couldn't record that decision.");
        }
        finally {
            setBusyId(null);
        }
    }
    return (<div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap", margin: "0 0 18px" }}>
        <div>
          <h1 style={{ fontWeight: 600, fontSize: "1.6rem", margin: 0 }}>Approvals</h1>
          <p style={{ color: "var(--ink-soft)", margin: "4px 0 0", fontSize: "0.85rem" }}>
            {isManagement ? "Requests awaiting a Management decision." : "Requests you have raised."}
          </p>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          {SCOPES.filter((s) => isManagement || !s.managementOnly).map((s) => (<button key={s.key} onClick={() => setScope(s.key)} style={{ ...chip, ...(scope === s.key ? chipActive : {}) }}>
              {s.label}
            </button>))}
        </div>
      </div>

      {error && <div style={{ color: "var(--st-risk)", marginBottom: 12 }}>{error}</div>}

      {items.map((r) => (<div key={r.id} style={{
                background: "var(--surface)",
                border: `1px solid ${r.isMyStep ? "var(--accent)" : "var(--line-soft)"}`,
                borderRadius: 10,
                marginBottom: 12,
                padding: "14px 18px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
            }}>
          <div style={{ minWidth: 0 }}>
            <div className="mono" style={{ fontSize: "0.65rem", color: "var(--accent-ink)", textTransform: "uppercase" }}>
              {r.actionType.replace(/_/g, " ")} · {r.status.replace(/_/g, " ")}
            </div>
            <div style={{ fontWeight: 700, fontSize: "0.9rem", marginTop: 2 }}>
              <Link to={`/legal-cases/cases/${r.caseId}`}>{r.caseCode}</Link> · Step {Math.min(r.currentStep, r.totalSteps)} of {r.totalSteps}
            </div>
            <div style={{ fontSize: "0.8rem", color: "var(--ink-soft)", marginTop: 3 }}>
              {r.requestedByName} · {new Date(r.requestedAt).toLocaleString()}{describe(r) ? ` · ${describe(r)}` : ""}
            </div>
          </div>

          {r.isMyStep ? (<div style={{ display: "flex", gap: 8, flex: "0 0 auto" }}>
              <button onClick={() => decide(r.id, "REJECTED")} disabled={busyId === r.id} style={rejectBtn}>
                Reject
              </button>
              <button onClick={() => decide(r.id, "APPROVED")} disabled={busyId === r.id} style={approveBtn}>
                Approve
              </button>
            </div>) : (<span className="mono" style={{ fontSize: "0.72rem", color: "var(--ink-faint)", flex: "0 0 auto" }}>
              {r.status === "APPROVED" || r.status === "REJECTED" ? "Decided" : "Awaiting approver"}
            </span>)}
        </div>))}

      {items.length === 0 && !error && (<div style={{ color: "var(--ink-faint)", fontSize: "0.85rem" }}>No approval requests here.</div>)}
    </div>);
}
const chip = { border: "1px solid var(--line)", background: "var(--surface)", color: "var(--ink-soft)", fontSize: "0.78rem", fontWeight: 600, padding: "6px 12px", borderRadius: 999, cursor: "pointer" };
const chipActive = { borderColor: "var(--brand)", background: "var(--brand-soft)", color: "var(--brand-ink)" };
const approveBtn = {
    background: "var(--st-open)",
    color: "#fff",
    fontWeight: 600,
    fontSize: "0.82rem",
    padding: "8px 16px",
    borderRadius: 8,
    border: "none",
    cursor: "pointer",
};
const rejectBtn = {
    background: "transparent",
    border: "1px solid var(--st-risk)",
    color: "var(--st-risk)",
    fontWeight: 600,
    fontSize: "0.82rem",
    padding: "8px 16px",
    borderRadius: 8,
    cursor: "pointer",
};
